import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import { ProfileData } from './components/profileData';
import LayoutAuthenticated from './components/LayoutAuthenticated';
import CallRecording from './components/callRecording';
import { ToastContainer } from "react-toastify";
import { appRoles } from './authConfig';
import "../node_modules/react-toastify/dist/ReactToastify.css";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TranscriberConfig from './components/Admin/transcriberConfig';
import RouteGuard from './components/Admin/routeGuard';

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/" component={Login} />
          <LayoutAuthenticated>
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/profile" component={ProfileData} />
            <Route path="/call-recording" component={CallRecording} />
            <RouteGuard path="/admin/config" roles={[appRoles.Admin]} component={TranscriberConfig} />
          </LayoutAuthenticated>
        </Switch>
      </Router>
      <ToastContainer draggable={false} />
    </>
  );
}

export default App;
